<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<span *ngIf="labelText">
  {{ labelText }}
  <span *ngIf="required" class="required"></span>
</span>
<div class="flex flex-row" [class.disabled]="disable" [class.invalid]="!isValid() && control?.dirty">
  <span class="prefix">{{ prefix }}</span>
  <textarea
    class="flex"
    (blur)="onBlur()"
    (focus)="focus.emit($event)"
    [(ngModel)]="value"
    (ngModelChange)="onModelChanged($event)"
    [class.none-right-border]="labelText && value"
    [placeholder]="getPlaceholderText()"
    [disabled]="disable"
    [maxlength]="maxLength"
  ></textarea>
  <div class="flex flex-row flex-nosize ml10">
    <label class="flex" [class.required]="isRequired">
      <ng-container *ngIf="(hasInlineInfo || keepPlaceholder) && value?.length > 0">
        {{ getPlaceholderText() }}
      </ng-container>
      <div class="flex-row flex-nosize">
        <rx-icon *ngIf="isPending" name="icon-spinner"></rx-icon>
        <rx-icon
          *ngIf="showReset && value?.length"
          class="light reset"
          name="icon-cross-circle-fill"
          (click)="onReset()"
        ></rx-icon>
      </div>
    </label>
  </div>
</div>
